<template>
  <!-- header_area -->
  <header>
    <div class="header_wrap" ref="header">
      <!--<header-bar></header-bar>-->
      <header-bar v-show="fixed" :class="{fixed: fixed}" :fixed="fixed" :direction="scrollInfo.direction" :top-offset="scrollInfo.position"></header-bar>
    </div>

    <q-scroll-observer @scroll="handleScroll" />

  </header>
  <!-- //header_area -->
</template>

<script>
  import {QScrollObserver} from 'quasar'
  import HeaderBar from './HeaderBar'
  import DisplayContainer from './DisplayContainer'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import { mapGetters } from 'vuex'
  export default {
    name: 'Header',
    components: {
      HeaderBar,
      DisplayContainer,
      QScrollObserver
    },
    data () {
      return {
        fixed: false,
        scrollInfo: {},
      }
    },
    computed: {
      ...mapGetters([
        'isToastBannerSmallSize'
      ]),
      getAccess () {
        return 'pc'
      },
    },
    methods: {
      ...CommonMethods,
      isCurrentRouteName (name) {
        return this.$route.name === name
      },
      handleScroll (info) {
        this.scrollInfo = info
        this.fixed = info.position > this.$refs.header.offsetTop + 400
      }
    }
  }
</script>

<style scoped>
  .header_wrap {
    position: relative;
    top: 0;
    width: 100%;
    transition: .15s;
    z-index: 2000;
  }
  .wallpaper .header_wrap {
    position: relative;
  }
  /deep/ .fixed {
    position: fixed;
    width: 100%;
    margin: 0 auto;
    top: 0;
    z-index: 2000;
  }
	/* on wallpaper */
	.wallpaper .header_wrap/deep/.fixed {
		max-width: 1300px;
	}
</style>
